export const SECRET_LIST_ITEM_SIZES = {
    base: 94,
    propertyRowSize: 44,
    sharingIndicator: 38.875,
    tags: 36,
};
